export const editor = ({
  borderRadius: 3,
  backgroundColor: '#fff',
  border: '1px solid #efefef'
})

export const editorFocus = ({
  border: '1px solid #51a7e8',
  outline: 'none',
  boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.075), 0 0 5px rgba(81,167,232,0.5)',
  marginTop: 10
})

export const editorToolbarContainer = ({
  position: 'relative'
})

export const editorToolbar = ({
  left: 0,
  position: 'inherit'
})

export const editorContainer = ({
  minHeight: 315
})

export const whatsappControlLabel = ({
  fontSize: '32px',
  verticalAlign: 'middle',
  color: '#005E52'
})

export const previewFinishPostDonation = ({
  display: 'flex',
  justifyContent: 'space-between'
})
